import { useState, useEffect } from 'react';
import { horodatyApi } from '@/lib/utils/horodaty-api';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetFooter } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { SubmitButton } from '@/components/ui/app/submit-button';
import FormCollaboratorEdit, { FORM_COLLABORATOR_EDIT_ID } from '../forms/FormCollaboratorEdit';
import { useTranslation } from 'react-i18next';

export default function SheetCollaboratorEdit({ open, onOpenChange, collaborator, onSubmit, isSubmitting }) {
    const { t } = useTranslation();
    const [resetKey, setResetKey] = useState(0);
    const [roles, setRoles] = useState([]);

    useEffect(() => {
        if (open) {
            setResetKey((k) => k + 1);
            horodatyApi
                .managerGetAvailableRoles()
                .then((response) => {
                    setRoles(response.data.data);
                })
                .catch((error) => {
                    console.error('Erreur lors de la récupération des rôles', error);
                });
        }
    }, [open]);

    return (
        <Sheet open={open} onOpenChange={onOpenChange}>
            <SheetContent
                className="w-[90vw] md:w-[500px]! md:max-w[500px]! flex flex-col p-0 gap-0"
                showCloseButton={false}
            >
                <SheetHeader className="p-5 border-b border-border flex-shrink-0">
                    <SheetTitle className="text-[18px] text-foreground">{t('subsidiary:modifierLeCollaborateur')}</SheetTitle>
                </SheetHeader>

                <FormCollaboratorEdit key={resetKey} collaborator={collaborator} onSubmit={onSubmit} roles={roles} />

                <SheetFooter className="p-5 border-t border-border flex-shrink-0 flex gap-3">
                    <Button
                        type="button"
                        variant="soft"
                        color="neutral"
                        onClick={() => onOpenChange(false)}
                        className="flex-1 rounded-xl py-3 h-auto text-[14px]"
                    >
                        {t('subsidiary:annuler')}
                    </Button>
                    <SubmitButton
                        isSubmitting={isSubmitting}
                        loadingText={t('subsidiary:enregistrement')}
                        form={FORM_COLLABORATOR_EDIT_ID}
                        className="flex-1 text-foreground rounded-xl py-3 h-auto text-[14px]"
                    >
                        {t('subsidiary:enregistrer')}
                    </SubmitButton>
                </SheetFooter>
            </SheetContent>
        </Sheet>
    );
}
